import React, { useRef, useContext, createContext } from 'react'

const ModalTargetContext = createContext<React.RefObject<HTMLDivElement>>({
  current: null,
})

export const useModalTargetRef = () => {
  return useContext(ModalTargetContext)
}

export const ModalProvider: React.FC = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <ModalTargetContext.Provider value={ref}>
      <div ref={ref} />
      {children}
    </ModalTargetContext.Provider>
  )
}
